export function isNotEmpty(value) {
    return !!value;
}

export function isNotNull(value) {
    if (value === undefined) {
        return false;
    }
    if (value === null) {
        return false;
    }
    return true
}

export function extractNumber(value) {
    return Number(String(value).replace(/[^0-9.]+/g, ""))
}